// extracted by mini-css-extract-plugin
module.exports = {"noImageWrapper":"_8ef29973","noImageIcon":"_c0a6927d","withSkeleton":"_19c76a6a","loader":"_d5a594ca","shineLoader":"_39855365","loaded":"_cc2744a5","preview":"_02d2cee1"};